import dayjs from 'dayjs';

export const GroupMessageSmsPreviewTime = () => {
  const showTime = dayjs().format('HH:MM');
  return <>{showTime}</>;
};
